<template>
  <vxe-grid
    ref="xTable"
    v-bind="gridOptions"
    :data="tableData"
    :height="tableHeight"
    :loading="loading"
  >
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      gridOptions: {
        size: 'mini',
        autoResize: true,
        columns: this.columns,
      },
    }
  },
  watch: {
    columns() {
      this.$refs.xTable.loadColumn(this.columns)
    },
  },
  methods: {
    getHeight() {
      const tableHeight = window.innerHeight - 231
      this.tableHeight = tableHeight < 680 ? 680 : tableHeight
    },
  },
}
</script>
